import Vue from 'vue'
import VueFlashMessage from 'vue-flash-message'
import Router from 'vue-router'
import Home from '@/components/Home'
import Login from '@/components/Login'
import ProfilePage from '@/components/ProfilePage'
import AdminProfile from '@/components/AdminProfile'
import Subscription from '@/components/Subscription'
import SearchData from '@/components/SearchData'
import Signup from '@/components/Signup'
import Confirm from '@/components/Confirm'
import Forgotpassword from '@/components/Forgotpassword'
import LeftSidebar from '@/components/sidebar/LeftSidebar'
import resetPassword from '@/components/resetPassword'
import UserProfile from '@/components/UserProfile'
import AccountSetting from '@/components/AccountSetting'
import Action from '@/components/Action'
import TermsAndCondition from '@/components/TermsAndCondition'
import FreeSignup from '@/components/FreeSignup'
import Escrow from '@/components/Escrow'

Vue.use(Router)
Vue.use(VueFlashMessage)
let router = new Router({
  mode: 'history',
  routes: [{
    path: '/',
    name: 'Home',
    component: Home,
    meta: {
      guest: true,
      layout: 'login-layout'
    }
  },
  {
    path: '/subscribe',
    name: 'Subscription',
    component: Subscription,
    meta: {
      guest: true,
      layout: 'login-layout'
    }
  },
  {
    path: '/freesignup',
    name: 'FreeSignup',
    component: FreeSignup,
    meta: {
      guest: true,
      layout: 'login-layout'
    }
  },
  {
    path: '/confirm',
    name: 'Confirm',
    component: Confirm
    // meta: {
    //   //guest: true,
    //   layout: 'login-layout',
    //   type: true
    // }
  },
  {
    path: '/termsandcondition',
    name: 'TermsAndCondition',
    component: TermsAndCondition,
    meta: {
      guest: true,
      layout: 'login-layout'
    }
  },
  {
    path: '/sidebar',
    name: 'LeftSidebar',
    component: LeftSidebar
  },
  {
    path: '/invoice',
    name: 'Invoice',
    component: require('@/components/Invoice').default,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/forgotpassword',
    name: 'Forgotpassword',
    component: Forgotpassword,
    meta: {
      guest: true,
      layout: 'login-layout'
    }
  },
  {
    path: '/resetPassword',
    name: 'resetPassword',
    component: resetPassword,
    meta: {
      guest: true,
      layout: 'login-layout'
    }
  },
  {
    path: '/login',
    name: 'login',
    component: Login,
    meta: {
      guest: true,
      layout: 'login-layout'
    }
  },
  {
    path: '/signup',
    name: 'Signup',
    component: Signup,
    meta: {
      guest: true,
      layout: 'login-layout'
    }
  },
  {
    path: '/escrow',
    name: 'Escrow',
    component: Escrow,
    meta: {
      guest: true,
      layout: 'login-layout'
    }
  },
  {
    path: '/admindashboard',
    name: 'AdminDashboard',
    component: require('@/components/AdminDashboard').default,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/userdashboard',
    name: 'UserDashboard',
    component: require('@/components/UserDashboard').default,
    meta: {
      requiresAuth: true,
      type: true
    }
  },
  {
    path: '/profilepage',
    name: 'ProfilePage',
    component: ProfilePage,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/adminprofile',
    name: 'AdminProfile',
    component: AdminProfile,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/searchdata',
    name: 'SearchData',
    component: SearchData,
    meta: {
      requiresAuth: true,
      type: true
    }
  },
  {
    path: '/action',
    name: 'Action',
    component: Action,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/account-setting',
    name: 'AccountSetting',
    component: AccountSetting,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/userprofile',
    name: 'UserProfile',
    component: UserProfile,
    meta: {
      requiresAuth: true,
      type: true
    }
  },
  {
    path: '/user',
    name: 'User',
    component: require('@/components/User').default,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/brands',
    name: 'Brands',
    component: require('@/components/Brands').default,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/payment',
    name: 'Payment',
    component: require('@/components/Payment').default,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/userpayment',
    name: 'PaymentUser',
    component: require('@/components/PaymentUser').default,
    meta: {
      requiresAuth: true,
      type: true
    }
  },
  {
    path: '/invoicedetail/:invoiceId/:page',
    name: 'invoiceDetail',
    component: require('@/components/invoiceDetail').default,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/paymentdetail',
    name: 'paymentDetail',
    component: require('@/components/paymentDetail').default,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/branddetail/:brandId/:page',
    name: 'brandDetail',
    component: require('@/components/brandDetail').default,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/userdetail/:userId/:page',
    name: 'userDetail',
    component: require('@/components/userDetail').default,
    meta: {
      requiresAuth: true
    }
  }
  ]
})
router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (localStorage.getItem('jwt') === 'undefined' || localStorage.getItem('jwt') === null) {
      next({
        path: '/login',
        params: {
          nextUrl: to.fullPath
        }
      })
    } else {
      let user = JSON.parse(localStorage.getItem('user'))
      if (user.role === 'admin') {
        if (to.matched.some(record => record.meta.auth)) {
          if (user.auth === true) {
            next({
              path: '/admindashboard',
              params: {
                nextUrl: to.fullPath
              }
            })
          }
        } else {
          next()
        }
      }
      if (user.role === 'user') {
        if (to.matched.some(record => !record.meta.type)) {
          if (user.auth === true) {
            next({
              path: '/userdashboard',
              params: {
                nextUrl: to.fullPath
              }
            })
          }
        } else {
          next()
        }
      }
    }
  } else if (to.matched.some(record => record.meta.guest)) {
    if (localStorage.getItem('jwt') === 'undefined' || localStorage.getItem('jwt') === null) {
      // alert('/admindashboard')
      next()
    } else {
      next({
        path: '/admindashboard',
        params: {
          nextUrl: to.fullPath
        }
      })
    }
  } else {
    next()
  }
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js